import React, { useCallback } from 'react'
import { SearchList } from './search-list'
import { IconUser } from '../../icon/icon'

const DisplayItemSelected = ({ selectText, item }) => {
  return (
    <React.Fragment>
      {item &&
        <span>
          <IconUser />
          {item.firstName} {item.lastName} ({item.email})
        </span>}

      {!item &&
        <span className="text-capitalize">
          {selectText || 'select'}
        </span>}
    </React.Fragment>
  )
}

const DisplayItemList = ({ item }) => {
  return (
    <React.Fragment>
      {item &&
        <span>
          <IconUser />
          {item.firstName} {item.lastName} ({item.email})
        </span>}
    </React.Fragment>
  )
}

const handleFilter = (items, value) => {
  if (!value) {
    return items
  }

  value = value.toLowerCase().trim().split(' ')

  return items.filter(item =>
    value.some(
      i => item.firstName.toLowerCase().includes(i) || item.lastName.toLowerCase().includes(i) || item.email.toLowerCase().includes(i)
    )
  )
}

export const SearchListCourseUser = ({ dropLeft, selectText, actionText, nullText, items, selectedItem, disabled, onAdd, onSelect }) => {
  const handleSelectedItem = useCallback(
    item => {
      if (item && selectedItem) {
        return item.userID === selectedItem.userID
      }

      return false
    },
    [selectedItem]
  )

  return (
    <React.Fragment>
      <SearchList
        dropLeft={dropLeft}
        items={items}
        selectedItem={selectedItem}
        DisplayItemSelected={DisplayItemSelected}
        DisplayItemList={DisplayItemList}
        selectText={selectText}
        actionText={actionText}
        nullText={nullText}
        disabled={disabled}
        fnFilter={handleFilter}
        fnSelectedItem={handleSelectedItem}
        onAdd={onAdd}
        onSelect={onSelect}
      />
    </React.Fragment>
  )
}
